<!--
 - App component
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2024 Build Centrix
 -->

<!--Layout and Content-->
<div [ngClass]="{'is__shown': isInitialized}" class="oauth2-ui fade-in">
  <div *ngIf="wdLocalSharedFunctionsService.useBanner">
    <bc-templates-banner-page
      [pageTitle]="wdLocalSharedFunctionsService.pageTitle"
      [pageSubtitle]="wdLocalSharedFunctionsService.pageSubtitle"
      [fullPage]="true"
      [privacyPolicyUrl]="wdLocalEnvironmentService.values.resources.getPrivacyPolicyUrl()"
      [termsAndConditionsUrl]="wdLocalEnvironmentService.values.resources.getTermsAndConditionsUrl()"
    >
      <!-- Transclude content (optional) -->
      <div bcx-banner-image>
        <!--suppress AngularNgOptimizedImage -->
        <img
          src="{{wdLocalSharedFunctionsService.bannerImage}}"
          class="group-image"
          [ngClass]="{ loaded: wdLocalSharedFunctionsService.bannerImageLoaded }"
          alt="bcx-oauth2-banner"
        />
      </div>
      <div bcx-banner-content>
        <router-outlet></router-outlet>
      </div>
    </bc-templates-banner-page>
  </div>
  <div *ngIf="!wdLocalSharedFunctionsService.useBanner">
    <router-outlet></router-outlet>
  </div>
  <div class="page-container" *ngIf="false">
    <div class="page-inner-container">
      <!--Banner Image-->
      <div class="page-image-container">
        <!--suppress AngularNgOptimizedImage -->
        <img
          src="{{wdLocalSharedFunctionsService.bannerImage}}"
          class="group-image"
          [ngClass]="{ loaded: wdLocalSharedFunctionsService.bannerImageLoaded }"
          alt="bcx-oauth2-banner"
        />
      </div>
      <!--Form Container-->
      <div class="page-form-container">
        <div class="form-inner-container">
          <!--View-->
          <router-outlet></router-outlet>
        </div>
        <div class="bottom-container">
          <div class="bottom-left copyright">
            © {{internalCompanyName}} {{currentYear}}
          </div>
          <div class="bottom-right legal">
            <a
              href="{{wdLocalEnvironmentService.values.resources.getPrivacyPolicyUrl()}}"
              target="_blank"
              >Privacy Policy</a
            >
            |
            <a
              href="{{wdLocalEnvironmentService.values.resources.getTermsAndConditionsUrl()}}"
              target="_blank"
              >Terms and Conditions</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Loader-->
<bc-atoms-loader
  *ngIf="!isInitialized"
  [title]="('actions.loading'|translate)"
  [active]="!isInitialized"
  [fullscreen]="true"
></bc-atoms-loader>
<!-- EOF -->
